import { Route } from '@angular/router';
import { IGuardData } from './guard-data.interface';

export interface IGuardRoute extends Route {
  name?: string;
  data: IGuardData;
}
